import { render, staticRenderFns } from "./ShareMenu.vue?vue&type=template&id=b96b2dfc&"
import script from "./ShareMenu.vue?vue&type=script&lang=js&"
export * from "./ShareMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports